import React, { Component } from 'react';
import { Grid, Cell } from 'react-md';
import { Link, Redirect } from 'react-router-dom';

import './Finished.css';

import { state, isStateEmpty } from '../services/state';

class Welcome extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		if (isStateEmpty()) {
			return <Redirect to="/" />;
		}

		return (
			<div className="Finished">
				<h2 className="title">Upload Complete!</h2>
				<Grid>
					<Cell
						size={6}
						tabletOffset={1}
						desktopOffset={3}
						className="welcome-selection-wrapper"
					>
						<h3 className="sub-section-title">
							Your files have been successfully uploaded.
						</h3>
						<p className="finished-text">
							You will receive an email confirmation and your
							Image Mill contact will reach out to you shortly. If
							you have any questions please feel free to call our
							customer service team at{' '}
							<a href="tel:1-360-217-7674">360.217.7674</a>
						</p>
					</Cell>
				</Grid>
				<Grid className="next-wrapper">
					<Cell size={6} tabletOffset={1} desktopOffset={3}>
						<Link to="/upload" className="primary-button">
							Upload More Files
						</Link>
					</Cell>
				</Grid>
			</div>
		);
	}
}

export default Welcome;



// WEBPACK FOOTER //
// ./src/pages/Finished.js